export const ACTION_MODEL = {
    CREATE:"CREATE",
    UPDATE:"UPDATE",
    DELETE:"DELETE",
    READ:"READ",
    OK : "OK",
    CANCEL:"CANCEL",
    DETAILS:"DETAILS",
    IMPORT: "IMPORT",
    EXPORT: "EXPORT",
    ADVANCE_SEARCH: "ADVANCE_SEARCH",
    CONTRACTOR_RESTRICTION: "CONTRACTOR_RESTRICTION",
    REFRESH:"REFRESH",
    CLEAR: "CLEAR",
    HIDE: "HIDE",
    VIEW: "VIEW",
}
